import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { Compound, MapMode } from '../types';
import { logEvent } from '../../../new-lib/analytics';
import { getPageLocation } from '../../../helpers/common';
import {
  setDrawerOpen,
  setDrawerPosition,
  setFirstDestination,
  setMapMode,
  setSecondDestination,
  setSearchDrawerOpen,
  setSelectedArea,
  setSelectedCompound
} from '../../../redux/slices/mapSlice';
import {
  SearchContext,
  SearchContextInterface
} from '../../search-new/context/SearchContext';
import { useContext } from 'react';
import { SearchFiltersActionTypes } from '../../../reducers/search-filters/actions';
import { SearchFiltersTypes } from '../../../reducers/search-filters/reducer';

const useMapActions = () => {
  const router = useRouter();
  const { searchFiltersDispatch, searchFiltersState } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const mapMode = useSelector((state: any) => state.map.mapMode);

  const firstDestination = useSelector(
    (state: any) => state.map.firstDestination
  );
  const secondDestination = useSelector(
    (state: any) => state.map.secondDestination
  );
  const compounds = useSelector((state: any) => state.map.compounds);
  const areas = useSelector((state: any) => state.map.areas);
  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );

  const dispatch = useDispatch();

  const selectCompound = (id: number) => {
    const compound = compounds?.find(
      (compound: Compound) => compound.id === id
    );
    if (mapMode === MapMode.CalculateDistance) {
      if (id === firstDestination?.id) {
        dispatch(setFirstDestination(null));
        return;
      }
      if (id === secondDestination?.id) {
        dispatch(setSecondDestination(null));
        return;
      }
      if (firstDestination && !secondDestination) {
        dispatch(setSecondDestination(compound));
      }
      if (
        (secondDestination && !firstDestination) ||
        (!firstDestination && !secondDestination)
      ) {
        dispatch(setFirstDestination(compound));
      }
    } else if (selectedCompound && id === selectedCompound.id) {
      dispatch(setSelectedCompound(null));
      dispatch(setMapMode(MapMode.SEARCH));
      dispatch(setDrawerPosition(35));
      if (router.asPath.includes('/nawy-now')) {
        searchFiltersDispatch({
          type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
          payload: {
            name: SearchFiltersTypes.COMPOUNDS,
            value: []
          }
        });
      }
    } else {
      dispatch(setSelectedCompound(compound));
      dispatch(setMapMode(MapMode.COMPOUND));
      dispatch(setDrawerOpen(true));
      if (router.asPath.includes('/nawy-now')) {
        setSelectedArea(null);
        searchFiltersDispatch({
          type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
          payload: {
            name: SearchFiltersTypes.AREAS,
            value: []
          }
        });
        searchFiltersDispatch({
          type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
          payload: {
            name: SearchFiltersTypes.COMPOUNDS,
            value: [id]
          }
        });
      }

      logEvent.click(
        'map_compound_click',
        getPageLocation(router.asPath),
        'map',
        { cmpnd_id: compound?.id, cmpnd_name: compound?.name }
      );
    }
  };
  const selectArea = (id: number) => {
    const area = areas?.find((area: any) => area.id === id);
    dispatch(setSelectedCompound(null));
    dispatch(setSelectedArea(area));
    dispatch(setMapMode(MapMode.SEARCH));
    dispatch(setDrawerOpen(true));
    dispatch(setSearchDrawerOpen(true));
    if (router.asPath.includes('/nawy-now')) {
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
        payload: {
          name: SearchFiltersTypes.AREAS,
          value: [id]
        }
      });
    }
  };

  return {
    selectCompound,
    selectArea
  };
};

export default useMapActions;
